/* @flow */
/* eslint-disable graphql/template-strings */
import idx from 'idx';
import { GET_REACTION_SUMMARY } from './queries';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';

export function currentReactionSummaryVersion(messageUuid: string) {
  const data = getApolloClientSingleton().readQuery({
    query: GET_REACTION_SUMMARY,
    variables: { messageUuid },
  });

  return idx(data, _ => _.reactionSummary.version) || -1;
}

export function saveReactionSummary(reactionSummary: ReactionSummaryGQL) {
  return getApolloClientSingleton().writeQuery({
    query: GET_REACTION_SUMMARY,
    variables: { messageUuid: reactionSummary.messageUuid },
    data: {
      reactionSummary,
    },
  });
}
